import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { RootState } from '../reducers';
import useEffectOnce from '../hooks/useEffectOnce';
import { fetchApprovedData, fetchAppliedData, fetchAllApplicationdData } from '../reduxactions/medicalofficeractions/MOApplicationActions';
import { InputText } from 'primereact/inputtext';
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';


export const MedicalOfficerApplications = () => {
    const uid = window.sessionStorage.getItem('uid');
    const photo = window.sessionStorage.getItem('photo');

    const [globalFilter, setGlobalFilter] = useState('');
    const stepperRef = useRef(null);



    const dispatch = useDispatch();
    const approved = useSelector((state: RootState) => state.mapplication.approved);
    const applied = useSelector((state: RootState) => state.mapplication.applied);
    const all = useSelector((state: RootState) => state.mapplication.allapplications);



    useEffectOnce(() => {
        const fetchDataAsync = async () => {
            try {
                await dispatch(fetchApprovedData(uid) as any);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchDataAsync();
    }, [dispatch]);
    useEffectOnce(() => {
        const fetchDataAsync1 = async () => {
            try {
                await dispatch(fetchAppliedData(uid) as any);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchDataAsync1();
    }, [dispatch]);
    useEffectOnce(() => {
        const fetchDataAsync1 = async () => {
            try {
                await dispatch(fetchAllApplicationdData(uid) as any);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchDataAsync1();
    }, [dispatch]);
    const navigate = useNavigate();
    const viewPage1 = (rowData: any) => {
        const url = `/mviewapproved/${rowData.application_ID}`;
        console.log('rowdata:', rowData.application_ID)
        navigate(url);
    }

    const viewPage2 = (rowData: any) => {
        const url = `/mviewapplied/${rowData.application_ID}`;
        console.log('rowdata:', rowData.application_ID)
        navigate(url);
    }
    const viewPage3 = (rowData: any) => {
        const url = `/mviewall/${rowData.application_ID}`;
        console.log('rowdata:', rowData.application_ID)
        navigate(url);
    }
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/medioffi-applications.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="main-content">
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="grid mb-2">
                            <div className="col-9">
                                <h2> Applications List</h2>
                            </div>
                            <div className="col-3">
                                <a
                                    title="help"
                                    onClick={(e) => openWindow(e, IUrl)}
                                    style={{

                                        color: "blue",
                                        fontSize: 15, cursor: "pointer"
                                    }}
                                >Help for this Page &nbsp;
                                    <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card-header p-2"></div>
                            <div className="box box-primary">
                                <div className="card"></div>
                                <div className="card flex flex-wrap justify-content">

                                </div>
                                <div className="card">
                                    <Stepper ref={stepperRef}>
                                        <StepperPanel header="Applied Applications">
                                            <p className="m-0">
                                                <div>
                                                    <div className="card flex flex-wrap justify-content">
                                                        <span className="p-input-icon-left">
                                                            <i className="pi pi-search" />
                                                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                        </span>
                                                    </div>
                                                    <div className="card">
                                                        <DataTable value={approved} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                            globalFilterFields={['FirstName', 'Sickness', 'hospitalname', 'status']}>
                                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                            <Column header="Patient Name" body={(rowData) => `${rowData.FirstName} `} />
                                                            <Column field="Sickness" sortable header="Sickness"></Column>
                                                            <Column field="hospitalname" sortable header="Hospital"></Column>
                                                            <Column field="status" sortable header="Status" body={(rowData) => rowData.status.charAt(0).toUpperCase() + rowData.status.slice(1).toLowerCase()} />
                                                            <Column header="Option" body={(rowData) => (
                                                                <div className="options-buttons">
                                                                    <Button icon="pi pi-eye" rounded outlined tooltip="View" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'blue', width: '2rem', height: '2rem' }} onClick={() => viewPage1(rowData)} />
                                                                </div>
                                                            )}></Column>
                                                        </DataTable>
                                                    </div>
                                                </div>
                                            </p>
                                        </StepperPanel>


                                        <StepperPanel header="Verified Applications">
                                            <p className="m-0">
                                                <div>
                                                    <div className="card flex flex-wrap justify-content">
                                                        <span className="p-input-icon-left">
                                                            <i className="pi pi-search" />
                                                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                        </span>
                                                    </div>
                                                    <div className="card">
                                                        <DataTable value={applied} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                            globalFilterFields={['FirstName', 'Sickness', 'hospitalname', 'status']}>
                                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                            <Column header="Patient Name" body={(rowData) => `${rowData.FirstName}`} />
                                                            <Column field="Sickness" sortable header="Sickness"></Column>
                                                            <Column field="hospitalname" sortable header="Hospital "></Column>
                                                            <Column field="status" sortable header="Status" body={(rowData) => rowData.status.charAt(0).toUpperCase() + rowData.status.slice(1).toLowerCase()} />
                                                            <Column header="Option" body={(rowData) => (
                                                                <div className="options-buttons">
                                                                    <Button icon="pi pi-eye" rounded outlined tooltip="View" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'blue', width: '2rem', height: '2rem' }} onClick={() => viewPage2(rowData)} />
                                                                </div>
                                                            )}></Column>
                                                        </DataTable>
                                                    </div>
                                                </div>
                                            </p>
                                        </StepperPanel>
                                        <StepperPanel header="All Applications">
                                            <p className="m-0">
                                                <div>
                                                    <div className="card flex flex-wrap justify-content">
                                                        <span className="p-input-icon-left">
                                                            <i className="pi pi-search" />
                                                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                        </span>
                                                    </div>
                                                    <div className="card">
                                                        <DataTable value={all} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                            globalFilterFields={['FirstName', 'Sickness', 'hospitalname', 'status']}>
                                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                            <Column header="Patient Name" body={(rowData) => `${rowData.FirstName}`} />
                                                            <Column field="Sickness" sortable header="Sickness"></Column>
                                                            <Column field="hospitalname" sortable header="Hospital "></Column>
                                                            <Column field="status" sortable header="Status" body={(rowData) => rowData.status.charAt(0).toUpperCase() + rowData.status.slice(1).toLowerCase()} />
                                                            <Column header="Option" body={(rowData) => (
                                                                <div className="options-buttons">
                                                                    <Button icon="pi pi-eye" rounded outlined tooltip="View" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'blue', width: '2rem', height: '2rem' }} onClick={() => viewPage3(rowData)} />
                                                                </div>
                                                            )}></Column>
                                                        </DataTable>
                                                    </div>
                                                </div>
                                            </p>
                                        </StepperPanel>
                                    </Stepper>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div >
        </div >)
}
